import React from 'react';
import { Form } from 'mobx-react-form';
import validatorjs from 'validatorjs';
import dvr from 'mobx-react-form/lib/validators/DVR';
import {
    validationExtension,
    formInvalidMessage
} from '../../_shared/validation/validationhelpers';
import flatten from '../util/flatten';
import { computed } from 'mobx';
import ceil from 'lodash.ceil';

export default class HTForm extends Form {
    store;
    appStore;
    helpURL;
    healthyHomesURL;

    constructor(props) {
        super(props);
        this.store = props.store;
        this.appStore = props.appStore;
        this.helpURL = props.appStore.helpURL;
        this.healthyHomesURL = props.appStore.healthyHomesURL;
    }

    /**
     * override mobx-react-form's idValid getter to also check if an invalid field is
     * hidden or not.
     */
    @computed get isValid() {
        // object of error messages
        const errors = flatten(this.errors());

        this.each(field => {
            if (errors[field.name]) {
                // set error message to null if field is hidden
                if (!document.getElementsByName(field.name).length) {
                    errors[field.name] = null;
                }
            }
        });

        // remove null values from error object
        Object.keys(errors).forEach((key) => (errors[key] == null) && delete errors[key]);

        // if we have remainign errors, these are ones that are legitimate (ie not hidden) erros
        return Object.keys(errors).length === 0;
    }

    plugins() {
        return {
            dvr: dvr({
                package: validatorjs,
                extend: validationExtension
            })
        };
    }

    options() {
        return {
            validateOnInit: false,
            validateOnChange: true,
            showErrors: true
        };
    }

    getDescription(content) {
        return <div dangerouslySetInnerHTML={{ __html: content.join('') }} />;
    }

    getHelpLink(hash, text, id) {
        return `<a href="${this.helpURL}#help-${hash}" data-help-id="${id}" target="_blank">${text}</a>`;
    }

    getHealthyHomesLink(text = 'Healthy homes standards insulation requirements', id = 'help-hhs_reqs') {
        return `<a href="${this.healthyHomesURL}" data-help-id="${id}" target="_blank">${text}</a>`;
    }

    setReadOnly(currentFields) {
        currentFields.forEach(field => {
            const origExtra = field.get('extra'),
                readonly = {
                    readOnly: true
                },
                extra = { ...origExtra, ...readonly };

            field.set('extra', extra);

            if (field.fields) {
                this.setReadOnly(field.fields);
            }
        });
    }

    disableFieldEditing() {
        this.setReadOnly(this.fields);
    }

    setExtraProps(extra) {
        this.setExtra(this.fields, extra);
    }

    setExtra(currentFields, extra) {
        currentFields.forEach(field => {
            if (field.type === 'rvaluefield') {
                field.set('extra', { ...field.get('extra'), ...extra });
            }

            if (field.fields) {
                this.setExtra(field.fields, extra);
            }
        });
    }

    setRemainingPercentage(value, form, targets) {
        if (value > 100 || value < 0) return;

        const updateTarget = target => {
            form.$(target).set('value', ceil(100 - value, 2));
        };

        if (Array.isArray(targets)) {
            targets.forEach(target => {
                updateTarget(target);
            });
        } else {
            updateTarget(targets);
        }
    }

    hooks() {
        return {
            onSuccess(form) {
                const values = form.values();
                this.store.save(values, form, true);
            },
            onError(form) {
                form.invalidate(formInvalidMessage);
            }
        };
    }
}
